import React, { useEffect, useState } from "react";
import useScrollReset from "@hooks/ScrollHook";
import { FetchStatus, useApi } from "@hooks/ApiHook";
import { useSelectedChain } from "@app/examples/ChainSelector";
import { Tabs } from "@components/tabs/Tabs";
import { MyCollectionTab } from "./tabs/MyCollectionTab";
import { Dropdown, DropdownMenu, DropdownToggle } from "react-bootstrap";
import { ShareDropdown } from "@components/dropdown/ShareDropdown";
import { MyNftTab } from "./tabs/MyNftTab";
import { useNavigate, useParams } from "react-router-dom";


function UserPage() {
    useScrollReset()
    const navigate = useNavigate()
    const { username } = useParams()
    const me = useApi(client => client.user.byUsername(username!))
    const { selectedChain: chain } = useSelectedChain()

    useEffect(() => {
        if (![FetchStatus.Init, FetchStatus.Loading].includes(me.status) && me.data == undefined) navigate("/not-found")
    }, [me.data])

    return <>
        <main className="pt-[5.5rem] lg:pt-24">
            <div className="relative bg-white/[.15]">
                <img src={me.data?.bannerUrl || "/src/img/logo/transparant_logo.png"} alt="banner" className="mx-auto h-[18.75rem] object-cover" />
            </div>

            <section className="relative bg-light-base pb-12 pt-28 dark:bg-dark">
                <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
                    <figure className="relative">
                        <img
                            width={"150rem"}
                            src={(me.data?.thumbUrl || "/src/img/logo/transparant_logo.png")}
                            alt="collection avatar"
                            className="rounded-xl border-[5px] border-white dark:border-gray-400 bg-default-image"
                        />
                        {
                            me.data?.isVerified
                            && <div className="absolute bottom-0 right-0 bg-green p-1 rounded-full z-20">
                                <svg style={{ color: "white" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16"> <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" fill="white"></path> </svg>
                            </div>
                        }
                    </figure>
                </div>

                <div className="container">
                    <div className="text-center flex flex-col items-center justify-center">
                        <h2 className="mb-2 font-display text-4xl font-medium text-jacarta-700 dark:text-white">
                            {me.data?.username || "Unknown"}
                        </h2>
                        <div
                            className="mb-5 inline-flex items-center justify-center rounded-full border border-jacarta-100 bg-white py-1.5 px-4 dark:border-gray-400 dark:bg-gray-900"
                        >
                            <img className="-ml-1 mr-2 h-[1.125rem] w-[1.125rem]" width={"20px"} src={chain?.imageUrl} />
                            <button
                                className="js-copy-clipboard max-w-[10rem] select-none overflow-hidden text-ellipsis whitespace-nowrap dark:text-white"
                                data-tippy-content="Copy">
                                <span>{me.data?.walletAddress}</span>
                            </button>
                        </div>

                        {
                            (me.data?.discordUrl || me.data?.instagramUrl || me.data?.twitterUrl || me.data?.whitepaperUrl) &&
                            <div className="flex items-center justify-center space-x-2.5">
                                <ShareDropdown
                                    discordUrl={me.data.discordUrl}
                                    twitterUrl={me.data.twitterUrl}
                                    instagramUrl={me.data.instagramUrl}
                                    whitepaperUrl={me.data.whitepaperUrl}
                                />
                            </div>
                        }

                    </div>
                </div>
            </section>


            {
                me.data && <section className="relative py-24 pt-20">
                    <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                        <img src="/src/img/gradient_light.jpg" alt="gradient" className="h-full w-full" />
                    </picture>

                    <div className="container">
                        <Tabs items={{
                            "Collection": <MyCollectionTab user={me.data} />,
                            "NFTs": <MyNftTab user={me.data} />
                        }} />
                    </div>
                </section>
            }
        </main>
    </>
}

export default UserPage;